export default __webpack_public_path__ + "static/media/Andrea_BIO_Image.ddfc60ec.jpg";